module.exports = __webpack_public_path__ + "img/hteam.bd3c6451.webp";